// @flow
import React from 'react';
import {css, StyleSheet} from 'aphrodite';
import {hslToHex} from "../utils";
import {greenHue, orangeHue, violetHue} from "../constants";
import Logo from "./Logo/Logo";
import Name from "./Name";
import SocialMediaContainer from "./SocialMediaContainer";


function App() {
  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.container)}>
        <header className={css(styles.header)}>
          <Logo />
          <Name />
          <SocialMediaContainer />
        </header>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    height: "100%",
    backgroundColor: hslToHex(orangeHue, 60, 8),
    color: hslToHex(orangeHue, 90, 50),
    fontSize: 16,
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  container: {
    maxWidth: 960,
    margin: "0 auto",
    padding: 40,
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  socialMediaContainer: {
    display: "flex",
    flexDirection: "row",
  },
  name: {
  },
});

export default App;

